import englishMessages from 'ra-language-english';

export const reactAdminBase = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    action: {
      ...englishMessages.ra.action,
      actions: 'Actions',
    },
    notification: {
      ...englishMessages.ra.notification,
      created: 'Item created successfully',
      updated: 'Item updated successfully |||| %{smart_count} items updated successfully',
      deleted: 'Item deleted successfully |||| %{smart_count} items deleted successfully',
      bad_item: 'Incorrect item',
      item_doesnt_exist: 'Item does not exist',
    },
  },
};